export default __webpack_public_path__ + "static/media/banner-img.44e0e951.svg";